export default "__VITE_ASSET__94ce5c09__"